// extracted by mini-css-extract-plugin
module.exports = {"root":"icon_root__nC2lM items-center inline-flex justify-center","icon":"icon_icon__ckKxp","icon_desktop":"icon_icon_desktop__WSPtw h-auto w-auto sm_h-[28px] sm_w-[28px]"};